import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useEffect } from "react";

const TestimonialsPreview = () => {
  const { i18n } = useTranslation();
  const isEs = i18n.language === "es";

  useEffect(() => {
    const existingScript = document.querySelector('script[src="https://reputationhub.site/reputation/assets/review-widget.js"]');
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://reputationhub.site/reputation/assets/review-widget.js";
      script.type = "text/javascript";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="pt-16 pb-0 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <span className="inline-block text-brand-green font-body text-sm font-semibold tracking-widest uppercase mb-2">
              {isEs ? "Testimonios" : "Testimonials"}
            </span>
            <h2 className="font-heading font-black text-brand-dark text-3xl md:text-4xl lg:text-5xl leading-tight">
              {isEs ? "Lo Que Dicen " : "What Our "}
              <span className="text-brand-green">{isEs ? "Nuestros Clientes" : "Clients Say"}</span>
            </h2>
          </div>
          <Link
            to="/testimonials"
            className="inline-flex items-center gap-2 border border-brand-dark/20 hover:border-brand-green hover:text-brand-green text-brand-dark px-5 py-2.5 rounded-full font-heading font-semibold text-sm transition-all cursor-pointer whitespace-nowrap self-start md:self-auto"
          >
            {isEs ? "Ver Todos" : "View All Reviews"}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

      </div>

      {/* ReputationHub Widget - full width, no fixed height */}
      <div className="w-full overflow-hidden">
        <iframe
          className="lc_reviews_widget"
          src="https://reputationhub.site/reputation/widgets/review_widget/Lcd1qbYzaBmMehdAkYeP"
          frameBorder={0}
          scrolling="no"
          style={{ minWidth: "100%", width: "100%", border: "none", display: "block" }}
          title="Customer Reviews"
        />
      </div>
    </section>
  );
};

export default TestimonialsPreview;
